const PasswordStrengthIndicator = ({ password }) => {
  const calculateStrength = (pass) => {
    let strength = 0;

    // Length check
    if (pass.length >= 6) strength += 1;
    if (pass.length >= 10) strength += 1;

    // Complexity checks
    if (/[A-Z]/.test(pass)) strength += 1; // Uppercase letter
    if (/[a-z]/.test(pass)) strength += 1; // Lowercase letter
    if (/[0-9]/.test(pass)) strength += 1; // Number
    if (/[^A-Za-z0-9]/.test(pass)) strength += 1; // Special character

    return Math.min(strength, 5); // Cap at 5 for our meter
  };

  const strength = calculateStrength(password);
  const strengthText = [
    "Very Weak",
    "Weak",
    "Moderate",
    "Strong",
    "Very Strong",
    "Excellent",
  ][strength];

  const strengthColor = [
    "danger",
    "danger",
    "warning",
    "btn-primary",
    "success",
    "success",
  ][strength];

  return (
    <div>
      <div className="d-flex align-items-center mb-1">
        <div className="progress flex-grow-1" style={{ height: "5px" }}>
          <div
            className={`progress-bar bg-${strengthColor}`}
            role="progressbar"
            style={{ width: `${(strength / 5) * 100}%` }}
            aria-valuenow={strength}
            aria-valuemin="0"
            aria-valuemax="5"
          ></div>
        </div>
        <small className="ms-2 text-muted">{strengthText}</small>
      </div>
      <small className="text-muted">
        Password should contain:
        <ul className="mb-0 p-3">
          <p>At least 6 characters (10 recommended)</p>
          <p>Uppercase and lowercase letters</p>
          <p>At least one number</p>
          <p>Special character (e.g., !@#$%)</p>
        </ul>
      </small>
    </div>
  );
};

export default PasswordStrengthIndicator;
